import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import { TextAreaInput } from "@/lib/Components/Form/Inputs/TextAreaInput";
import { BookingChangeRequestListItem } from "@/app/Bookings/GraphQL/bookingChangeRequestListQuery";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { resolveChangeRequestMutation } from "@/app/Bookings/GraphQL/bookingChangeRequestMutations";
import { BookingChangeRequestStatus } from "@/gql/graphql";
import { z } from "zod";
import { toFormikValidationSchema } from "@/lib/Zod/zod-formik-adapter";

const validation = z.object({
  note: z.string().min(3),
});
export function BookingChangeRequestActionedDialog({
  changeRequest,
}: {
  changeRequest: BookingChangeRequestListItem;
}) {
  const { close } = useDialogState();
  const { mutateAsync } = useGqlMutation(resolveChangeRequestMutation);

  return (
    <BaseDialog
      title="Mark Change Request Actioned"
      subtitle="Tell the customer that the change request has been actioned and that we're awaiting a response"
    >
      <div className="mb-6 rounded-md border border-gray-200 bg-gray-50 p-6 leading-7 shadow-md">
        {changeRequest.request}
      </div>

      <GenericForm
        validationSchema={toFormikValidationSchema(validation)}
        initialValues={{
          note: "",
        }}
        onSubmit={async (values) => {
          await mutateAsync({
            id: changeRequest.id,
            input: {
              status: BookingChangeRequestStatus.Actioned,
              note: values.note,
            },
          });
          close();
        }}
      >
        <TextAreaInput
          name="note"
          label="Customer note"
          description="Add a note that will be sent to the customer"
          className="col-span-full"
        />

        <DialogSubmitButton text="Action" />
      </GenericForm>
    </BaseDialog>
  );
}
